export const CREATE_VIDEOFLO_SESSION = "CREATE_VIDEOFLO_SESSION";
export const DELETE_VIDEOFLO_SESSION = "DELETE_VIDEOFLO_SESSION";
export const VIDEOFLO_SIZE_SMALL = "VIDEOFLO_SIZE_SMALL";
export const VIDEOFLO_SIZE_FULL = "VIDEOFLO_SIZE_FULL";
